import { render, staticRenderFns } from "./LangSelector.vue?vue&type=template&id=281c72ce&scoped=true"
import script from "./LangSelector.vue?vue&type=script&lang=js"
export * from "./LangSelector.vue?vue&type=script&lang=js"
import style0 from "./LangSelector.vue?vue&type=style&index=0&id=281c72ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "281c72ce",
  null
  
)

export default component.exports